module.exports = __webpack_public_path__ + "img/minzizhirongyus.71096ccf.png";